const databaseName = 'trafiken-region-preference';
const databaseVersion = 1;
const storeName = 'preferences';
const selectedRegionKey = 'selected-region-url';

function openDatabase(): Promise<IDBDatabase> {
    return new Promise((resolve, reject) => {
        const request = indexedDB.open(databaseName, databaseVersion);

        request.onupgradeneeded = () => {
            if (!request.result.objectStoreNames.contains(storeName)) {
                request.result.createObjectStore(storeName);
            }
        };
        request.onsuccess = () => resolve(request.result);
        request.onerror = () => reject(request.error);
    });
}

export function normalizeRegionUrl(value: unknown, origin: string): string | null {
    if (typeof value !== 'string') {
        return null;
    }

    try {
        const url = new URL(value, origin);
        if (url.origin !== origin || url.pathname === '/' || url.search || url.hash) {
            return null;
        }

        return url.pathname;
    } catch {
        return null;
    }
}

export async function readSelectedRegionUrl(origin: string): Promise<string | null> {
    const database = await openDatabase();

    try {
        const value = await new Promise<unknown>((resolve, reject) => {
            const request = database.transaction(storeName, 'readonly').objectStore(storeName).get(selectedRegionKey);
            request.onsuccess = () => resolve(request.result);
            request.onerror = () => reject(request.error);
        });

        return normalizeRegionUrl(value, origin);
    } finally {
        database.close();
    }
}

export async function writeSelectedRegionUrl(value: string, origin: string): Promise<void> {
    const regionUrl = normalizeRegionUrl(value, origin);
    if (!regionUrl) {
        return;
    }

    const database = await openDatabase();

    try {
        await new Promise<void>((resolve, reject) => {
            const transaction = database.transaction(storeName, 'readwrite');
            transaction.objectStore(storeName).put(regionUrl, selectedRegionKey);
            transaction.oncomplete = () => resolve();
            transaction.onerror = () => reject(transaction.error);
            transaction.onabort = () => reject(transaction.error);
        });
    } finally {
        database.close();
    }
}
